export enum UserAppType {
    CLIENT = 'Client',
    OPERATOR = 'Operator',
    TAXI_SERVANT = 'TaxiServant',
    DELIVERY_DRIVER = 'DeliveryDriver',
}

